import { useEffect } from 'react'
import { SetURLSearchParams } from 'react-router-dom'

export const useStartParamsDish = (setSearchParams: SetURLSearchParams) => {
  useEffect(() => {
    setSearchParams((sp) => {
      sp.set('is_archived', 'false')
      return sp
    }, { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
